import React from 'react'

import styles from './DragHandle.module.css'

const DragHandle = React.forwardRef<HTMLDivElement, any>((_, ref) => {
  return (
    <div
      className={styles.Handle}
      ref={ref}
      onMouseDown={e => {
        e.stopPropagation()
      }}
    >
      <div className={styles.BulletGrid}>
        <div className={styles.Bullet} />
      </div>
      <div className={styles.BulletGrid}>
        <div className={styles.Bullet} />
      </div>
      <div className={styles.BulletGrid}>
        <div className={styles.Bullet} />
      </div>
      <div className={styles.BulletGrid}>
        <div className={styles.Bullet} />
      </div>
      <div className={styles.BulletGrid}>
        <div className={styles.Bullet} />
      </div>
      <div className={styles.BulletGrid}>
        <div className={styles.Bullet} />
      </div>
    </div>
  )
})

export default DragHandle
